export function formatAsPrice(number) {
  return (typeof number === 'number') ? ("$" + number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) : number
}
